import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CommonReducedProduct, CommonProduct } from '../models/Products';
import { Pagination } from '../models/Pagination';
import { CacheService } from './cache.service';
import { HttpService } from './http.service';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class ProductsService {
    constructor(
        private httpService: HttpService,
        private cacheService: CacheService
    ) {}

    getProducts(): Observable<Array<CommonReducedProduct>> {
        return this.httpService.get<Array<CommonReducedProduct>>(environment.apiCommonV3BaseUrl + '/products-list').pipe(
            map((product) => product)
        );
    }

    getProductsPaginated(paginationSize = 15, paginationOffset = 0, startingAfter = null, endingBefore = null): Observable<Pagination> {

        let params = {
            paginationSize: paginationSize,
            paginationOffset: paginationOffset,
            startingAfter: startingAfter,
            endingBefore: endingBefore,
            nameContains: null,
            referenceContains: null
        };

        let httpParams: HttpParams = new HttpParams();

        Object.keys(params).forEach((k) => {
            params[k] && (httpParams = httpParams.set(k, params[k]));
        });

        return this.httpService.get<any>(environment.apiCommonV3BaseUrl + '/products-paginated', {
            params: httpParams,
            observe: 'response'
        }).pipe(
            map((response) => {
                return <Pagination> {
                    paginationSize,
                    paginationOffset,
                    startingAfter,
                    endingBefore,
                    total: response.headers && response.headers.get('x-pagination') ? JSON.parse(response.headers.get('x-pagination')).totalCount : null,
                    items: <Array<CommonReducedProduct>>response.body,
                }

            })
        );
    }

    getProductsSearchPaginated(paginationSize = 50, paginationOffset = 0, startingAfter = null, endingBefore = null, searchTerm = null): Observable<Pagination> {
        let params = {
            paginationSize: paginationSize,
            paginationOffset: paginationOffset,
            startingAfter: startingAfter,
            endingBefore: endingBefore,
            q: searchTerm
        };

        let httpParams: HttpParams = new HttpParams();

        Object.keys(params).forEach((k) => {
            params[k] && (httpParams = httpParams.set(k, params[k]));
        });

        return this.httpService.get<any>(environment.apiCommonV3BaseUrl + '/products-search', {
            params: httpParams,
            observe: 'response'
        }).pipe(
            map((response) => {
                return <Pagination> {
                    paginationSize,
                    paginationOffset,
                    startingAfter,
                    endingBefore,
                    total: response.headers && response.headers.get('x-pagination') ? JSON.parse(response.headers.get('x-pagination')).totalCount : null,
                    items: <Array<CommonReducedProduct>>response.body,
                }
            })
        );
    }

    getProduct(id: number): Observable<CommonProduct> {
        if (this.cacheService.hasItem('product', id)) {
            return of(this.cacheService.getItem('product', id));
        } else {
            return this.httpService.get<CommonProduct>(`${environment.apiCommonV3BaseUrl}/products/${id}`).pipe(
                map((product) => this.cacheService.setItem('product', id, product))
            );
        }
    }
}
